import React, { useEffect } from "react";
import { observer } from "mobx-react";
import "primeflex/primeflex.css";
import { ReadinessReviewViewModel } from "./ReadinessReviewViewModel";
import Utils from "../../infrastructure/Utils";
import "../enhancedReports/EnhancedReportsView.css";
import UserContext from "../../infrastructure/UserContext";
import { routes } from "../../router";
import { respondToAuthCacheRequest } from "../../infrastructure/authCacheRelay";
import { getToken } from "../../infrastructure/Auth0Authenticator";

// Plain function component, deliberately NOT wrapped in observer(): this
// codebase's mobx-react@5 wraps observer() function components as class
// components under the hood, and hooks can't run inside a class component's
// render() (see MarketersView.tsx's MarketersAuthRelay for the same trap).
const ReadinessReviewAuthRelay: React.FC<{ rtsBaseUrl: string }> = ({
  rtsBaseUrl,
}) => {
  useEffect(() => {
    // Warm this token now, before the iframe's REQUEST_AUTH_CACHE arrives.
    // getToken() serializes through acquireToken()'s Web Lock, which is also
    // queued behind every other API call this page fires on load - asking
    // for it lazily inside respondToAuthCacheRequest means it can lose the
    // child's cold-load timeout race.
    getToken().catch(() => {});

    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== rtsBaseUrl) return;
      respondToAuthCacheRequest(event, rtsBaseUrl);
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [rtsBaseUrl]);

  return null;
};

export const ReadinessReviewView: React.FC<{
  vm: ReadinessReviewViewModel;
}> = observer((props) => {
  let env = Utils.getAppHostKey();
  let rtsUrl =
    `https://rts-${env}.integrityconnect.com/app?tenantName=${Utils.getBUName()}&connectUserId=${UserContext.getUserId()}`
      .replace("-prod", "");
  // let rtsUrl = `http://localhost:3001/app`; // enable only for local development
  const rtsBaseUrl = new URL(rtsUrl).origin;

  return (
    <>
        <div className="er-container">
          <ReadinessReviewAuthRelay rtsBaseUrl={rtsBaseUrl} />
          <iframe src={`${rtsUrl}`} id="bob-iframe" frameBorder="0" />
        </div>
    </>
  );
});
